// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePlayerSeasonStatsGetBody = {
  playerId: string;
};

export type typePlayerSeasonStatsGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    playerId: string;
    teamId: string;
    leagueId: string;
    leagueSeasonId: string;
    seasonLabel: string | null;
    hasLeagueStats: boolean;
    hasStats: boolean;
    groups: {
      groupKey: string;
      label: string;
      stats: {
        statKey: string;
        label: string;
        displayValue: string;
        rankLabel: string | null;
      }[];
    }[];
  };
};

export type typePlayerSeasonStatsGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePlayerSeasonStatsGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePlayerSeasonStatsGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPlayerSeasonStatsGetBody = {
  type: "object",
  properties: { playerId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["playerId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPlayerSeasonStatsGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPlayerSeasonStatsGetBody);
  }

  return async function postPlayerSeasonStatsGet(
    payload: typePlayerSeasonStatsGetBody,
  ): Promise<
    typePlayerSeasonStatsGetOutput200 | typePlayerSeasonStatsGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPlayerSeasonStatsGet" failed before calling the network. #4c05c25c3473`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#4c05c25c3473" },
        },
        data: null,
      } as typePlayerSeasonStatsGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/player/season-stats-get`,
      httpMethod: "POST",
      options,
    })) as
      typePlayerSeasonStatsGetOutput200 | typePlayerSeasonStatsGetOutput400;
  };
}
